module.exports = __webpack_public_path__ + "img/mockup-desktop.78c67b5e.png";